import { useEffect, useState } from 'react';
import { DeliveredLooseOrderView } from 'types';
import API from '../../API';
import { message } from 'antd';

export const useDeliveredLooseOrders = () => {
	const [orders, setOrders] = useState<DeliveredLooseOrderView[]>();

	useEffect(() => {
		fetch();
	}, []);

	const fetch = async () => {
		try {
			const fetchedOrders = await API.looseOrders.getDelivered();
			setOrders(fetchedOrders);
		} catch (e) {
			console.trace(e);
			message.error(`Nie udało się pobrać danych ${e}`);
		}
	};

	return { orders };
};
